import { AttioDealOption, SalesPerson, SubscriptionPriceEstimate } from "src/api-service";
import { AppError } from "../../../app-store-error.types";

// ============================================================================
// QUOTE SUBSCRIPTION CREATE STATE
// Used for creating new subscription quotes (price estimate wizard)
// ============================================================================

export interface QuoteSubscriptionCreateState {
    priceEstimate: SubscriptionPriceEstimate | null;
    loading: boolean;
    /** The quote's salesperson, whose open Attio deals are offered to pick from. */
    salesPerson: SalesPerson | null;
    /** The Attio deal the quote is for. It decides the customer, who is then credit-checked. */
    deal: AttioDealOption | null;
    loadingDealCustomer: boolean;
    dealCustomerError: AppError | null;
}

export const initialQuoteSubscriptionCreateState: QuoteSubscriptionCreateState = {
    priceEstimate: null,
    loading: false,
    salesPerson: null,
    deal: null,
    loadingDealCustomer: false,
    dealCustomerError: null,
};
